"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasSingleGolferRate = void 0;
const getActiveContracts_1 = require("./getActiveContracts");
const dayjs = require("dayjs");
const hasSingleGolferRate = (date, contracts) => {
    // get the active golf contract
    const activeContracts = (0, getActiveContracts_1.getActiveContracts)(date, contracts);
    const selected_date = date || dayjs().add(3, "day").format("YYYY-MM-DD");
    const futureContracts = activeContracts.filter((contract) => {
        const contractDate = new Date(contract.start_date);
        const currentDate = new Date(selected_date);
        return contractDate.getTime() > currentDate.getTime();
    });
    const currentContracts = activeContracts
        .filter((contract) => {
        const contractStartDate = new Date(contract.start_date);
        const contractEndDate = new Date(contract.end_date);
        const currentDate = new Date(selected_date);
        return (contractStartDate.getTime() <= currentDate.getTime() &&
            contractEndDate.getTime() >= currentDate.getTime());
    })
        .sort((a, b) => {
        // sort by contracts on promotion first
        if (a.type === "PROMOTIONAL_RATE" && b.type !== "PROMOTIONAL_RATE")
            return -1;
        if (a.type !== "PROMOTIONAL_RATE" && b.type === "PROMOTIONAL_RATE")
            return 1;
        return 0;
    });
    // if there are no current contracts, get the first future contract
    let contract = currentContracts[0] || futureContracts[0];
    if (!contract)
        return false;
    let hasSingleGolferRate = false;
    contract = contract;
    contract.products?.forEach((product) => {
        product.rates?.forEach((rate) => {
            if (rate.min_pax === 1)
                hasSingleGolferRate = true;
        });
    });
    return hasSingleGolferRate;
};
exports.hasSingleGolferRate = hasSingleGolferRate;
